import { graphql } from 'react-relay';
/**
 * This query hardcodes status to be "draft" because we only need to
 * validate the page title in the editor (the "draft" state).
 * Draft in this context does not necessarily refer to a page that has never been published.
 * A published page's "draft" state refers to the version that persists in the editor.
 */
export const ValidatePagePublishQuery = graphql`
	query ValidatePagePublishQuery($contentId: ID!, $type: String, $title: String) {
		validatePagePublish(id: $contentId, status: "draft", type: $type, title: $title) {
			isValid
			message
		}
	}
`;
